import React from "react";
import { View, StyleSheet, Image } from "react-native";
import NtSectionDescription from "./NtSectionDescription";
import NtSectionTitle from "./NtSectionTitle";
import NtTouchableEffect from "../../../components/NtTouchableEffect";
import NtText from "../../../components/NtText";
import NtMaterialIcon from "../../../components/NtMaterialIcon";
import { useNavigation } from "@react-navigation/native";
import routes from "../../../navigation/routes";
import NtMarketingLogo from "./NtMarketingLogo";
import { useMobile } from "../../../hooks/useMobile";

function NtMarketingPageContainerFooter({ containerStyle }) {
  const nav = useNavigation();
  const isMobile = useMobile();

  const company = [
    {
      id: "aboutus",
      title: "About Us",
      action: () => {
        nav.navigate(routes.aboutus);
      },
    },
    {
      id: "support",
      title: "Support",
      action: () => {
        window.open("https://support.ntconnect.com/en-us/");
      },
    },
    {
      id: "patents",
      title: "Patents",
      action: () => {
        nav.navigate(routes.patent);
      },
    },
    {
      id: "terms",
      title: "Terms of Service",
      action: () => {
        nav.navigate(routes.tos);
      },
    },
    {
      id: "privacy",
      title: "Privacy Policy",
      action: () => {
        nav.navigate(routes.privacy);
      },
    },
  ];

  const other = [
    {
      id: "nooz",
      title: "NOOZ.ai",
      action: () => {
        window.open("https://nooz.ai/app");
      },
    },
    {
      id: "devops",
      title: "NT DevOps",
      action: () => {
        nav.navigate(routes.devops);
      },
    },

    {
      id: "maritime",
      title: "NT Maritime",
      action: () => {
        window.open("https://ntmaritime.com");
      },
    },
    {
      id: "911",
      title: "NT E911 Service",
      action: () => {
        nav.navigate(routes.e911);
      },
    },
  ];

  const impact = [
    {
      id: "nooz",
      title: "NOOZ.ai",
      action: () => {
        nav.navigate(routes.impactstudy, { type: "nooz" });
      },
    },
    {
      id: "avaya",
      title: "Avaya Gov Solution",
      action: () => {
        nav.navigate(routes.impactstudy, { type: "avaya" });
      },
    },
    {
      id: "cunard",
      title: "Cunard Line",
      action: () => {
        nav.navigate(routes.impactstudy, { type: "cunard" });
      },
    },
    {
      id: "disney",
      title: "Disney Cruise Line",
      action: () => {
        nav.navigate(routes.impactstudy, { type: "disney" });
      },
    },
    {
      id: "holland",
      title: "Holland America Line",
      action: () => {
        nav.navigate(routes.impactstudy, { type: "holand" });
      },
    },
    {
      id: "ncl",
      title: "Norwegian Cruise Line",
      action: () => {
        nav.navigate(routes.impactstudy, { type: "ncl" });
      },
    },
    {
      id: "tritan",
      title: "Tritan Software SeaCare",
      action: () => {
        nav.navigate(routes.impactstudy, { type: "tritan" });
      },
    },
    {
      id: "navi-carrier-strike-group",
      title: "Navy Carrier Strike Group",
      action: () => {
        nav.navigate(routes.impactstudy, { type: "navi-carrier-strike-group" });
      },
    },
    {
      id: "national-guard",
      title: "Wyoming Air National Guard",
      action: () => {
        nav.navigate(routes.impactstudy, { type: "national-guard" });
      },
    },
    {
      id: "navy-communications",
      title: "Navy Communications at NAS Key West",
      action: () => {
        nav.navigate(routes.impactstudy, { type: "navy-communications" });
      },
    },
  ];

  const follow = [
    {
      id: "linkedin",
      title: "LinkedIn",
      icon: "linkedin",
      action: () => {
        window.open("https://www.linkedin.com/company/ntconnect/");
      },
    },
  ];

  const renderRow = (item) => {
    return (
      <NtTouchableEffect
        key={item.id}
        style={{ flexDirection: "row", alignItems: "center", marginTop: 14 }}
        onPress={item.action}
      >
        {item.icon && (
          <NtMaterialIcon
            containerStyle={{ marginRight: 4 }}
            name={item.icon}
            color="white"
          />
        )}
        <NtText style={{ fontSize: 11, color: "white" }}>{item.title}</NtText>
      </NtTouchableEffect>
    );
  };

  return (
    <View style={[styles.container, containerStyle]}>
      <View
        style={[
          {
            width: "100%",
            maxWidth: "90%",
            flexDirection: "row",
          },
          isMobile ? { flexDirection: "column" } : {},
        ]}
      >
        <NtMarketingLogo
          containerStyle={{
            marginTop: isMobile ? -12 : -20,
            marginLeft: isMobile ? -12 : 0,
          }}
          onPress={() => {
            nav.navigate(routes.marketing);
          }}
        />

        <View
          style={[
            {
              flex: 1,
              flexDirection: "row",
              justifyContent: "space-around",
            },
            isMobile ? { flexDirection: "column-reverse" } : {},
          ]}
        >
          {/* company */}
          <View style={{ marginTop: isMobile ? 30 : 0 }}>
            <NtSectionTitle
              style={{ fontSize: 12, fontWeight: "700", textAlign: "left" }}
            >
              COMPANY
            </NtSectionTitle>
            {company?.map((each) => renderRow(each))}

            <NtSectionTitle
              style={{
                fontSize: 12,
                fontWeight: "700",
                textAlign: "left",
                marginTop: 25,
              }}
            >
              ALSO FROM NT CONNECT
            </NtSectionTitle>
            {other?.map((each) => renderRow(each))}
          </View>

          {/* impact */}
          <View style={{ marginTop: isMobile ? 10 : 0 }}>
            <NtSectionTitle
              style={{ fontSize: 12, fontWeight: "700", textAlign: "left" }}
            >
              IMPACT STUDIES
            </NtSectionTitle>
            {impact?.map((each) => renderRow(each))}
          </View>
        </View>

        {/* Fallow */}
        <View style={{ marginTop: isMobile ? 30 : 0 }}>
          <NtSectionTitle style={{ fontSize: 12, textAlign: "left" }}>
            Follow us
          </NtSectionTitle>
          {follow?.map((each) => renderRow(each))}
        </View>
      </View>

      <View style={{ width: "100%", maxWidth: "90%", marginTop: 35 }}>
        <NtSectionDescription style={{ textAlign: "center", fontSize: 12 }}>
          A leading provider of communication intelligence and IT solutions,
          specializing in building and managing mission-critical communication
          networks.
        </NtSectionDescription>
        <NtSectionDescription
          style={{ textAlign: "center", fontSize: 12, marginTop: 4 }}
        >
          (C) {new Date().getFullYear()} NT Connect - All Rights Reserved
        </NtSectionDescription>
      </View>
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    alignItems: "center",
  },
});

export default NtMarketingPageContainerFooter;
